export default {
  title: 'Kreditkarte hinzufügen',
  buttons: {
    save: 'Speichern',
  },
  feedback: {
    success: 'Karte erfolgreich hinzugefügt',
  },
};
